import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { NAV_LINKS, SITE } from '../lib/config';
import { track } from '../lib/analytics';

export function Header() {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-border-subtle bg-bg-elevated/95 backdrop-blur">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-6 lg:px-8">
        <Link to="/" className="flex items-center gap-2 text-lg font-bold text-text-primary">
          <span className="inline-flex h-8 w-8 items-center justify-center rounded-lg bg-primary text-white">
            IE
          </span>
          {SITE.name}
        </Link>

        <nav className="hidden items-center gap-6 md:flex">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`text-sm font-medium transition-colors ${
                pathname === link.to ? 'text-primary' : 'text-text-secondary hover:text-text-primary'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/pricing"
            onClick={() => track('pricing_click', { location: 'header_desktop', plan: 'pro' })}
            className="rounded-full bg-primary px-4 py-2 text-sm font-semibold text-white hover:bg-primary-hover"
          >
            Upgrade to Pro
          </Link>
        </nav>

        <button
          className="rounded-md p-2 text-text-secondary hover:bg-bg-elevated-2 md:hidden"
          aria-label="Toggle menu"
          onClick={() => setOpen((v) => !v)}
        >
          <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            {open ? (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            )}
          </svg>
        </button>
      </div>

      {open && (
        <div className="border-t border-border-subtle bg-bg-elevated px-4 py-3 md:hidden">
          <nav className="flex flex-col gap-3">
            {NAV_LINKS.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`text-sm font-medium ${
                  pathname === link.to ? 'text-primary' : 'text-text-secondary'
                }`}
                onClick={() => setOpen(false)}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/pricing"
              className="rounded-full bg-primary px-4 py-2 text-center text-sm font-semibold text-white"
              onClick={() => {
                setOpen(false);
                track('pricing_click', { location: 'header_mobile', plan: 'pro' });
              }}
            >
              Upgrade to Pro
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}
